import { useMeta } from '@interhyp/platform-meta';
import { useCallback } from 'react';

import { Remote } from '../interfaces/Remote';

export const useFilteredRemotes = (): ((remotes: Remote[]) => Remote[]) => {
  const { stage } = useMeta();

  return useCallback(
    (remotes: Remote[]) => {
      return remotes.filter(remote => !remote.onlyOnStages || remote.onlyOnStages.includes(stage));
    },
    [stage],
  );
};
